import React from 'react';

import { IToastContent } from './Toast';

interface IToastContext {
  add: (content: IToastContent) => void;
  remove: (id: string) => void;
}

const ToastContext = React.createContext<IToastContext>({} as IToastContext);

export default ToastContext;
